 import { type MarginStatus } from "@/lib/pricing-calculations";
 import { cn } from "@/lib/utils";
 import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
 
 interface PricingStatusBadgeProps {
   status: MarginStatus;
   realMargin: number;
   targetMargin: number;
 }
 
 const statusConfig = {
   healthy: {
     icon: CheckCircle2,
     label: "MARGEM SAUDÁVEL",
     description: "O preço atual está adequado",
     bgColor: "bg-green-100 dark:bg-green-900/30",
     textColor: "text-green-700 dark:text-green-400",
     iconColor: "text-green-600 dark:text-green-400",
   },
   warning: {
     icon: AlertTriangle,
     label: "ATENÇÃO",
     description: "Margem abaixo do ideal",
     bgColor: "bg-yellow-100 dark:bg-yellow-900/30",
     textColor: "text-yellow-700 dark:text-yellow-400",
     iconColor: "text-yellow-600 dark:text-yellow-400",
   },
   critical: {
     icon: XCircle,
     label: "MARGEM CRÍTICA",
     description: "Risco de prejuízo",
     bgColor: "bg-red-100 dark:bg-red-900/30",
     textColor: "text-red-700 dark:text-red-400",
     iconColor: "text-red-600 dark:text-red-400",
   },
 };
 
 export function PricingStatusBadge({ status, realMargin, targetMargin }: PricingStatusBadgeProps) {
   const config = statusConfig[status];
   const Icon = config.icon;
 
   return (
     <div className={cn("flex items-center gap-3 p-3 rounded-lg", config.bgColor)}>
       <Icon className={cn("h-5 w-5 flex-shrink-0", config.iconColor)} />
       <div className="flex-1 min-w-0">
         <p className={cn("font-semibold text-sm", config.textColor)}>
           {config.label}
         </p>
         <p className={cn("text-xs", config.textColor, "opacity-80")}>
           {config.description} • Meta: {targetMargin.toFixed(0)}% | Atual: {realMargin.toFixed(1)}%
         </p>
       </div>
     </div>
   );
 }